// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  margin-top: -10px;
}

p.disclaimer {
  color: #000000 !important;
  font-size: 14px;
  padding: 0px 10px 10px;
  width: 80%;
  font-family: sans-serif;
  margin: auto;
}
p.disclaimer label span {
  display: inline-block;
  background: #fff;
  padding: 10px;
  color: orange;
  box-shadow: 0px 0px 4px rgba(85, 85, 85, 0.4);
}
p.disclaimer .expan-down-arrow {
  display: flex;
  justify-content: center;
}
p.disclaimer .expan-down-arrow a {
  background-color: #fff;
  padding: 7px;
}
p.disclaimer .expan-down-arrow a .fa {
  font-size: 1.5rem !important;
}

#leave-planner {
  background: transparent;
  width: 90%;
  min-height: 100vh;
  position: relative;
  margin: 10px auto;
}
#leave-planner form {
  position: relative;
  margin-bottom: 10px;
  display: inline-block;
  width: 98%;
  background: #fff;
  padding: 1rem;
  box-shadow: 1px 0px 4px rgba(85, 85, 85, 0.4);
  border-radius: 5px;
}
#leave-planner label {
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 10px;
  width: 70%;
  display: inline-block;
}

.select {
  width: 100%;
}

select {
  width: 100%;
  border-radius: 5px;
  border-color: #565c78;
  color: #000 !important;
}

.is-rounded {
  color: #000 !important;
}

#chat-list {
  position: relative;
  overflow-y: auto;
  height: calc(100vh - 260px);
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
#chat-list li {
  list-style: none;
}

.button:hover {
  background: var(--primaryColor) !important;
  color: #fff !important;
}

.answer-list {
  margin: 10px 0px;
}

.answer {
  background: #fff;
  min-height: 50px;
  border-radius: 5px;
  padding: 10px;
  color: #666;
  margin: 0.2rem 0;
  display: flex;
  flex-direction: column;
  width: 98%;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
}
.answer .answer-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 15px;
}
.answer .answer-header span {
  font-weight: bold;
}
.answer .audio {
  cursor: pointer;
}
.answer .menu-list {
  position: relative;
  width: 30%;
}
.answer .menu-list ul {
  position: absolute;
  top: -10px;
  right: 0px;
  width: max-content;
}
.answer .menu-list ul li {
  margin: 10px 10px;
  display: inline-block;
  cursor: pointer;
  /* .fa{
   color: #008cb3;
  } */
}
.answer .menu-list ul li:hover .fa {
  color: #008cb3;
}
.answer .menu-list ul.active {
  display: block;
}
.answer .menu-list label {
  width: 20px;
  display: flex;
  justify-content: center;
  cursor: pointer;
}
.answer .dropdown-menu {
  left: -55px !important;
}
.answer .dropdown-item {
  padding: 0px !important;
}
.answer .dropdown-item li {
  margin: 5px 0px !important;
  font-size: 12px !important;
  width: 100%;
  padding: 5px 10px;
}
.answer .dropdown-item li:hover {
  background: var(--primarylightColor);
  color: var(--primaryColor);
}

.answer-content {
  position: relative;
  padding: 5px;
  line-height: 1.6;
  font-size: 0.9rem;
  color: #111;
}
.answer-content ol {
  padding: 30px;
}

.comment-area-box::after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  top: 1px;
  left: 99%;
  box-sizing: border-box;
  border: 10px solid rgba(0, 0, 0, 0.5);
  border-color: transparent transparent #fff #fff;
  transform-origin: 0 0;
  transform: rotate(135deg);
  box-shadow: -1px 1px 1px 0 rgba(0, 0, 0, 0.35);
}

.comment-area-box {
  display: none;
  background: #fff;
  padding: 15px 10px 5px;
  width: 80%;
}
.comment-area-box label {
  width: -moz-fit-content !important;
  width: fit-content !important;
}
.comment-area-box textarea {
  resize: none;
}
.comment-area-box .form-btns {
  width: 100%;
  display: flex;
  margin: 5px 0px;
}
.comment-area-box .form-btns .btn:first-child {
  border: 1px solid #dbdbdb;
  background: #fff !important;
  color: #000 !important;
}
.comment-area-box .form-btns .btn {
  --bs-btn-line-height:1.2 !important;
  font-size: 0.9rem !important;
  padding: 5px 20px;
  color: #fff;
  background: var(--primaryColor);
  margin-right: 15px;
  border: none;
  cursor: pointer;
  font-family: "Noto Sans", sans-serif;
}

.comment-area-box.is-active {
  display: flex;
  margin-top: 10px;
  align-items: center;
}

.comment-form {
  margin-left: 10px;
}
.comment-form label {
  font-size: 0.9rem;
}
.comment-form textarea {
  margin-right: 25px;
}
.comment-form .comments-field {
  margin-top: 10px;
}
.comment-form .comments-field form {
  box-shadow: none !important;
}
.comment-form .comments-field .form-btns {
  float: right;
}
.comment-form .button:hover {
  background: var(--primaryColor) !important;
  color: #fff !important;
}

@media screen and (min-width: 320px) and (max-width: 767px) {
  .hidemobileView {
    display: none;
  }
}
@media screen and (max-width: 640px) {
  #chat-list {
    height: calc(100vh - 360px) !important;
  }
  .answer-header label {
    margin-top: 15px !important;
  }
  #leave-planner {
    width: 100%;
    left: 0%;
  }
  #leave-planner label {
    margin-bottom: 0px;
  }
  p.disclaimer {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/ai-assist/botleave-planner/botleave-planner.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,iBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,eAAA;EAEA,sBAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;AAAJ;AACI;EACI,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,6CAAA;AACR;AACM;EACC,aAAA;EACA,uBAAA;AACP;AAAO;EACE,sBAAA;EACA,YAAA;AAET;AADS;EACE,4BAAA;AAGX;;AAEA;EACI,uBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EAGA,iBAAA;AADJ;AAGI;EACI,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,6CAAA;EACA,kBAAA;AADR;AAII;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,UAAA;EACA,qBAAA;AAFR;;AAMA;EACI,WAAA;AAHJ;;AAMA;EACI,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;AAHJ;;AAKA;EACI,sBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;AAFJ;AAII;EACI,gBAAA;AAFR;;AAOI;EACI,0CAAA;EACA,sBAAA;AAJR;;AAQA;EACI,gBAAA;AALJ;;AAOA;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,wFAAA;AAJJ;AAMI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAJR;AAKQ;EACI,iBAAA;AAHZ;AAQI;EACI,eAAA;AANR;AASI;EACI,kBAAA;EACA,UAAA;AAPR;AAQS;EACG,kBAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;AANZ;AAQY;EACI,iBAAA;EACA,qBAAA;EACA,eAAA;EACA;;KAAA;AAJhB;AASY;EACI,cAAA;AAPhB;AAWS;EACG,cAAA;AATZ;AAYQ;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AAVZ;AAeI;EACI,sBAAA;AAbR;AAgBI;EACI,uBAAA;AAdR;AAeO;EACK,0BAAA;EACA,0BAAA;EACA,WAAA;EACA,iBAAA;AAbZ;AAgBO;EACK,oCAAA;EACA,0BAAA;AAdZ;;AAoBA;EACG,kBAAA;EAEA,YAAA;EACA,gBAAA;EACA,iBAAA;EACC,WAAA;AAlBJ;AAoBI;EACI,aAAA;AAlBR;;AAuBA;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,qCAAA;EACA,+CAAA;EACA,qBAAA;EACA,yBAAA;EACA,8CAAA;AApBJ;;AAsBA;EAKM,aAAA;EACF,gBAAA;EACA,sBAAA;EAEA,UAAA;AAxBJ;AA0BI;EACI,kCAAA;EAAA,6BAAA;AAxBR;AA0BI;EACI,YAAA;AAxBR;AA0BI;EACI,WAAA;EACA,aAAA;EACA,eAAA;AAxBR;AAyBQ;EACI,yBAAA;EACA,2BAAA;EACA,sBAAA;AAvBZ;AA0BQ;EACI,mCAAA;EACA,4BAAA;EACA,iBAAA;EACA,WAAA;EACA,+BAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,oCAAA;AAxBZ;;AA8BA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;AA3BF;;AA6BA;EACI,iBAAA;AA1BJ;AA2BI;EACI,iBAAA;AAzBR;AA2BI;EACI,kBAAA;AAzBR;AA4BI;EACI,gBAAA;AA1BR;AA2BQ;EACI,2BAAA;AAzBZ;AA2BQ;EACI,YAAA;AAzBZ;AA8BQ;EACI,0CAAA;EACA,sBAAA;AA5BZ;;AAiCC;EACG;IACI,aAAA;EA9BN;AACF;AAkCA;EACI;IACG,sCAAA;EAhCL;EAmCM;IACI,2BAAA;EAjCV;EAoCE;IACI,WAAA;IACA,QAAA;EAlCN;EAmCM;IACI,kBAAA;EAjCV;EAoCE;IACI,WAAA;EAlCN;AACF","sourcesContent":[":host{\n    width:100%;\n    margin-top: -10px;\n}\n \np.disclaimer{\n    color: #000000 !important;\n    font-size: 14px;\n  \n    padding:0px 10px 10px;\n    width: 80%;\n    font-family: sans-serif;\n    margin: auto;\n    label span{\n        display: inline-block;\n        background: #fff;\n        padding: 10px;\n        color: orange;\n        box-shadow:0px 0px 4px rgba(85, 85, 85, 0.4);\n    }\n      .expan-down-arrow{\n       display: flex;\n       justify-content: center;\n       & a{\n         background-color:#fff;\n         padding:7px;\n         .fa{\n           font-size:1.5rem !important;\n         }\n       }\n      }\n   }\n#leave-planner{\n    background:transparent;\n    width:90%;\n    min-height:100vh;\n    position:relative;\n    // left:5%;\n    // padding:2% 3%;\n    margin:10px auto;\n\n    form{\n        position: relative;\n        margin-bottom: 10px;\n        display: inline-block;\n        width: 98%;\n        background: #fff;\n        padding: 1rem;\n        box-shadow: 1px 0px 4px #5556;\n        border-radius: 5px;\n    }\n\n    label{\n        font-size: 1rem;\n        font-weight: bold;\n        margin-bottom: 10px;\n        width:70%;\n        display: inline-block;\n    }\n}\n\n.select{\n    width:100%;\n}\n \nselect{\n    width:100%;\n    border-radius:5px;\n    border-color: #565c78;\n    color:#000 !important;\n}\n.is-rounded{\n    color:#000 !important;\n}\n\n#chat-list{\n    position: relative;\n    overflow-y: auto;\n    height:calc(100vh - 260px);\n    -ms-overflow-style: none;  /* IE and Edge */\n    scrollbar-width: none;  /* Firefox */\n\n    li{\n        list-style: none;\n      \n    }\n}\n.button{\n    &:hover{\n        background: var(--primaryColor)!important;\n        color:#fff!important;\n    }\n}\n\n.answer-list{\n    margin:10px 0px;\n}\n.answer{\n    background: #fff;\n    min-height:50px;\n    border-radius:5px;\n    padding:10px;\n    color: #666;\n    margin:.2rem 0;\n    display: flex;\n    flex-direction: column;\n    width:98%;\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n    \n    .answer-header{\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        gap: 15px;\n        span{\n            font-weight:bold;\n        }\n    \n    }\n\n    .audio{\n        cursor: pointer;\n    }\n\n    .menu-list{\n        position: relative;\n        width:30%;\n         ul{\n            position: absolute;\n            top:-10px;\n            right:0px;\n            width:max-content;\n        \n            li{\n                margin:10px 10px;\n                display:inline-block;\n                cursor: pointer;\n                /* .fa{\n                 color: #008cb3;\n                } */\n            }\n            li:hover{\n            .fa{\n                color: #008cb3;\n               }\n           }\n        }\n         ul.active{\n            display: block;\n        }\n\n        & label{\n            width:20px;\n            display:flex;\n            justify-content: center;\n            cursor: pointer;\n        }\n\n\n    }\n    .dropdown-menu{\n        left:-55px !important;\n        // top:-100px !important;\n    }\n    .dropdown-item {\n        padding:0px !important;\n       & li{\n            margin:5px 0px !important;\n            font-size:12px !important;\n            width:100%;\n            padding:5px 10px;\n        }\n\n       & li:hover{\n            background: var(--primarylightColor);\n            color:var(--primaryColor);\n        }\n    }\n}\n\n \n.answer-content{\n   position: relative;\n \n   padding:5px;\n   line-height:1.6;\n   font-size:.9rem;\n    color: #111;\n    \n    & ol{\n        padding:30px;\n    }\n}\n\n\n.comment-area-box::after{\n    content: \"\";\n    position: absolute;\n    width: 0;\n    height: 0;\n    top: 1px;\n    left: 99%;\n    box-sizing: border-box;\n    border: 10px solid rgba(0, 0, 0, 0.5);\n    border-color: transparent transparent #fff #fff;\n    transform-origin: 0 0;\n    transform: rotate(135deg);\n    box-shadow: -1px 1px 1px 0 rgba(0, 0, 0, 0.35);\n  }\n.comment-area-box{\n    // position: absolute;\n    // z-index: 999;\n    // top:40px;\n    // right:0px;\n      display: none;\n    background: #fff;\n    padding:15px 10px 5px;\n    // box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 5px;\n    width:80%;\n\n    label{\n        width: fit-content !important;\n    }\n    textarea{\n        resize: none;\n    }\n    .form-btns{\n        width:100%;\n        display: flex;\n        margin:5px 0px;\n        .btn:first-child{\n            border:1px solid #dbdbdb;\n            background:#fff !important;\n            color:#000 !important;\n          }\n\n        .btn{\n            --bs-btn-line-height:1.2 !important;\n            font-size:.9rem !important;\n            padding:5px 20px;\n            color:#fff;\n            background: var(--primaryColor);\n            margin-right:15px;\n            border: none;\n            cursor: pointer;\n            font-family:\"Noto Sans\", sans-serif;\n          }\n    }\n\n\n}\n.comment-area-box.is-active{\n  display: flex;\n  margin-top:10px;\n  align-items: center;\n}\n.comment-form{\n    margin-left:10px;\n    label{\n        font-size:.9rem;\n    }\n    textarea{\n        margin-right:25px;\n    }\n\n    .comments-field{\n        margin-top: 10px;\n        form{\n            box-shadow: none !important;\n        }\n        .form-btns{\n            float: right;\n        }\n    }\n\n    .button{\n        &:hover{\n            background: var(--primaryColor)!important;\n            color:#fff!important;\n        }\n    }\n}\n \n @media screen and (min-width: 320px) and (max-width: 767px) {\n    .hidemobileView{\n        display: none;\n    }\n   \n}\n \n@media screen and (max-width:640px) {\n    #chat-list{\n       height: calc(100vh - 360px) !important;\n    }\n    .answer-header{\n        label{\n            margin-top:15px !important;\n        }\n    }\n    #leave-planner{\n        width:100%;\n        left:0%;\n        label{\n            margin-bottom:0px;\n        }\n    }\n    p.disclaimer{\n        width:100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
